import { bool } from "prop-types";

import * as S from "./styled";

const { ContactBoxHeader } = S;

ContactBoxHeader.propTypes = {
  isMobile: bool
};

ContactBoxHeader.defaultProps = {
  isMobile: false
};

ContactBoxHeader.displayName = "ContactBoxHeader";

export default ContactBoxHeader;
